module.exports = __webpack_public_path__ + "img/snx.9803069e.svg";